export default __webpack_public_path__ + "static/media/quack-edited-short.b082cd68.mp3";